import { Button } from '@/components/ui';
import { Plus, CreditCard } from 'lucide-react';
import { cn } from '@/lib/utils';
import HeaderPageControls from './HeaderPageControls';
import { CurrencyEnum } from '@/enums';
import { amountToString } from '@/functions';
import type { IHeaderPageMobileProps } from '@/interfaces';

const HeaderPageMobile = ({
	incomeTotal,
	expenseTotal,
	netBalance,
	dateRange,
	onDateRangeChange,
	onQuickPeriod,
	isLoading,
	onOpenCreate
}: IHeaderPageMobileProps) => {
	return (
		<div className="flex flex-col space-y-4 md:hidden -mx-4 px-4 py-6 bg-zinc-50/50 border-b border-zinc-100 mb-2">
			<div className="flex items-center justify-between">
				<div className="flex items-center space-x-2">
					<div className="bg-white p-1.5 rounded-lg border border-zinc-200 shadow-xs">
						<CreditCard size={16} className="text-zinc-600" />
					</div>
					<h2 className="text-lg font-bold tracking-tight text-zinc-800">Transactions</h2>
				</div>
			</div>

			<div className="bg-white border border-zinc-200 p-1 rounded-xl shadow-xs">
				<HeaderPageControls
					dateRange={dateRange}
					onDateRangeChange={onDateRangeChange}
					onQuickPeriod={onQuickPeriod}
					isLoading={isLoading}
				/>
			</div>

			<div className="bg-white border border-zinc-200/60 rounded-3xl overflow-hidden shadow-[0_2px_10px_-3px_rgba(0,0,0,0.07)]">
				<div
					className={cn(
						'p-5 flex flex-col space-y-1 border-b border-zinc-100',
						netBalance >= 0 ? 'bg-emerald-500/2' : 'bg-rose-500/2'
					)}
				>
					<span className="text-zinc-400 text-[10px] font-bold uppercase tracking-widest">Balance Nette</span>
					<div className="flex items-baseline space-x-1">
						<span className={cn('text-3xl font-black tracking-tighter', netBalance >= 0 ? 'text-emerald-600' : 'text-rose-600')}>
							{amountToString(netBalance, CurrencyEnum.EUR)}
						</span>
					</div>
				</div>

				<div className="grid grid-cols-2 divide-x divide-zinc-100 h-14">
					<div className="flex flex-col items-center justify-center space-y-0.5">
						<span className="text-[9px] font-bold text-zinc-400 uppercase tracking-tight">Revenus</span>
						<span className="text-sm font-extrabold text-emerald-600">{amountToString(incomeTotal, CurrencyEnum.EUR)}</span>
					</div>

					<div className="flex flex-col items-center justify-center space-y-0.5">
						<span className="text-[9px] font-bold text-zinc-400 uppercase tracking-tight">Dépenses</span>
						<span className="text-sm font-extrabold text-rose-600">
							{amountToString(expenseTotal > 0 ? -expenseTotal : expenseTotal, CurrencyEnum.EUR)}
						</span>
					</div>
				</div>
			</div>

			<Button
				onClick={onOpenCreate}
				className="w-full h-11 bg-zinc-900 text-white hover:bg-zinc-800 rounded-xl flex items-center justify-center space-x-2 font-semibold shadow-md active:scale-[0.98] transition-all"
			>
				<Plus size={16} />
				<span className="text-sm">Nouvelle Transaction</span>
			</Button>
		</div>
	);
};

export default HeaderPageMobile;
